import React, { Component } from 'react';

class Footer extends Component {
  render() {
    return (
      <div className="footer flex-1 center">
        <h6>Handmade by <a href="https://github.com/francheska-guzman">Francheska Guzman</a></h6>
      </div>
    );
  }
}

export default Footer;